import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './img/hinova/logo.png';
import _imports_1 from './img/hinova/figure1.png';
const _hoisted_1 = {
  class: "hinova-success-case"
};
const _hoisted_2 = {
  class: "success-case-banner"
};
const _hoisted_3 = {
  class: "case-info"
};
const _hoisted_4 = {
  class: "case-name"
};
const _hoisted_5 = {
  class: "tit"
};
const _hoisted_6 = {
  class: "case-title"
};
const _hoisted_7 = {
  class: "case-title"
};
const _hoisted_8 = {
  class: "desc"
};
const _hoisted_9 = {
  class: "doc-btn"
};
const _hoisted_10 = {
  class: "breadcrumb-box"
};
const _hoisted_11 = {
  class: "page-title"
};
const _hoisted_12 = {
  class: "customer-message"
};
const _hoisted_13 = {
  class: "message-info"
};
const _hoisted_14 = {
  class: "message-txt"
};
const _hoisted_15 = {
  class: "principal"
};
const _hoisted_16 = {
  class: "page-title"
};
const _hoisted_17 = {
  class: "thema-desc"
};
const _hoisted_18 = {
  class: "page-title"
};
const _hoisted_19 = {
  class: "thema-desc"
};
const _hoisted_20 = {
  class: "thema-desc"
};
const _hoisted_21 = {
  class: "emphasis"
};
const _hoisted_22 = {
  class: "emphasis"
};
const _hoisted_23 = {
  class: "thema-desc"
};
const _hoisted_24 = {
  class: "bottom-banner"
};
const _hoisted_25 = {
  class: "banner-con"
};
const _hoisted_26 = {
  class: "title"
};
const _hoisted_27 = {
  class: "consult-btn"
};
export function render(_ctx, _cache) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[0] || (_cache[0] = _createElementVNode("img", {
    src: _imports_0
  }, null, -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('successCase.text19')), 1)]), _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('successCase.text20')), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('successCase.text21')), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('successCase.text22')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('successCase.text32')), 1)])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_breadcrumb, {
    separator: "/"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, {
      to: {
        path: '/successCase'
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('successCase.text75')), 1)]),
      _: 1
    }), _createVNode(_component_el_breadcrumb_item, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('successCase.text82')), 1)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('successCase.text6')), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('successCase.text23')), 1), _createElementVNode("p", _hoisted_15, "— " + _toDisplayString(_ctx.$t('successCase.text24')), 1)])]), _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t('successCase.text9')), 1), _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('successCase.text25')) + " " + _toDisplayString(_ctx.$t('successCase.text26')), 1), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "thema-figure"
  }, [_createElementVNode("img", {
    class: "thema-img",
    src: _imports_1
  })], -1)), _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t('successCase.text11')), 1), _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('successCase.text27')), 1), _createElementVNode("p", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('successCase.text28')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text29')), 1), _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('successCase.text30')), 1)]), _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('successCase.text31')), 1), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.$t('successCase.text17')), 1), _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('successCase.text18')), 1)])])]);
}